"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationVerificationStatus = void 0;
exports.instanceOfCertificationVerificationStatus = instanceOfCertificationVerificationStatus;
exports.CertificationVerificationStatusFromJSON = CertificationVerificationStatusFromJSON;
exports.CertificationVerificationStatusFromJSONTyped = CertificationVerificationStatusFromJSONTyped;
exports.CertificationVerificationStatusToJSON = CertificationVerificationStatusToJSON;
exports.CertificationVerificationStatusToJSONTyped = CertificationVerificationStatusToJSONTyped;
/**
 *
 * @export
 */
exports.CertificationVerificationStatus = {
    Pending: 'PENDING',
    Verified: 'VERIFIED',
    NotVerified: 'NOT_VERIFIED'
};
function instanceOfCertificationVerificationStatus(value) {
    for (const key in exports.CertificationVerificationStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.CertificationVerificationStatus, key)) {
            if (exports.CertificationVerificationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function CertificationVerificationStatusFromJSON(json) {
    return CertificationVerificationStatusFromJSONTyped(json, false);
}
function CertificationVerificationStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CertificationVerificationStatusToJSON(value) {
    return value;
}
function CertificationVerificationStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=CertificationVerificationStatus.js.map